<template>
  <div class="latest-posts">
    <h1 class="display-1">
      {{ $t('home.latest') }}
    </h1>
    <br clear="all" />

    <!-- Desktop Layout -->
    <div class="desktop-view">
      <div class="posts-grid">
        <PostCardComponent
          v-for="edge in posts.edges" 
          :key="edge.node.id" 
          :post="edge.node" 
        />
        <div v-if="posts.pageInfo.hasNextPage && posts.edges.length > 0" class="load-more-container">
          <button @click="loadMorePosts" class="btn btn--primary btn-wide btn--large">
            {{ $t('buttons.load_more') }}
          </button>
        </div>
      </div>
      <br clear="all" />
      <EmptyComponent v-if="!loading && posts.edges.length === 0" />
    </div>

    <!-- Mobile Layout -->
    <div class="mobile-view">
      <div class="mobile-grid">
        <PostCardComponent
          v-for="edge in posts.edges" 
          :key="edge.node.id" 
          :post="edge.node" 
          :isShort="edge.node.id === 5" 
          class="mobile-item"
        />
  
        <div v-if="posts.pageInfo.hasNextPage && posts.edges.length > 0" class="load-more-container">
          <button @click="loadMorePosts" class="btn btn--primary btn-wide btn--large">
            {{ $t('buttons.load_more') }}
          </button>
        </div>
      </div>
      <EmptyComponent v-if="!loading && posts.edges.length === 0" />
    </div>

    <br clear="all" />
    <div style="display: flex; flex-direction: column; align-items: center;position:relative">
      <AdBanner />
    </div>
  </div>
</template>

<script>
import PostCardComponent from '@/components/Posts/PostCardComponent.vue';
import EmptyComponent from '@/components/EmptyComponent.vue';
import AdBanner from '@/components/Ads/AdBanner.vue';

import { ref, onMounted, onUnmounted } from 'vue';

export default {
  name: 'LatestPosts',
  components: {
    PostCardComponent,
    EmptyComponent,
    AdBanner,
  },
  props: {
    posts: {
      type: Object,
      required: true,
      validator: (value) => {
        return value.edges && value.pageInfo;
      }
    },
    loadMorePosts: {
      type: Function,
      required: true
    }
  },
  setup() {
    const isMobile = ref(false);

    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
      const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      const isSmallScreen = window.innerWidth <= 768;
      
      isMobile.value = isMobileDevice || hasTouch || isSmallScreen;
    };

    onMounted(() => {
      checkMobile();
      window.addEventListener('resize', checkMobile);
      window.addEventListener('orientationchange', checkMobile);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('orientationchange', checkMobile);
    });

    return {
      isMobile
    };
  },
};
</script>

<style scoped>
.display-1 {
  margin-top: 3rem;
}

.AdBanner {
  position: relative;
  width: 100%;
  margin-top: auto;
}

.latest-posts {
  width: 100%;
  margin: 2rem 0;
  padding: 20px;
  box-sizing: border-box;
}

/* Desktop Layout */
.desktop-view {
  display: block;
}

.posts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

/* Mobile Layout */
.mobile-view {
  display: none;
}

.mobile-grid {
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
}

.mobile-item {
  width: 100%;
  margin: 0;
}

.load-more-container {
  grid-column: 1 / -1;
  width: 100%;
  text-align: center;
  margin-top: 20px;
  position: relative;
  z-index: 1;
}

.load-more-container button {
  width: 100%;
  margin: 0 auto;
}

@media (max-width: 768px), (hover: none) {
  .latest-posts {
    padding: 15px;
  }

  .desktop-view {
    display: none;
  }

  .mobile-view {
    display: block;
  }

  .mobile-grid {
    width: 100%;
    gap: 30px;
  }

  .mobile-item {
    width: 100%;
    margin-bottom: 30px;
  }

  .load-more-container {
    margin-top: 15px;
    position: relative;
    z-index: 1;
  }
}

/* Force mobile layout for touch devices */
@media (hover: none) {
  .desktop-view {
    display: none;
  }

  .mobile-view {
    display: block;
  }
}
</style>
  